/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadyitemhours3Inputs */

const en_searchreadyitemhours3 = /** @type {(inputs: Searchreadyitemhours3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening hours`)
};

const de_searchreadyitemhours3 = /** @type {(inputs: Searchreadyitemhours3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnungszeiten`)
};

/**
* | output |
* | --- |
* | "Opening hours" |
*
* @param {Searchreadyitemhours3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadyitemhours3 = /** @type {((inputs?: Searchreadyitemhours3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadyitemhours3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadyitemhours3(inputs)
	return de_searchreadyitemhours3(inputs)
});
export { searchreadyitemhours3 as "searchReadyItemHours" }